export default {
  label: {
    series: {
      openTickets: 'Tickets abiertos',
      closedTickets: 'Tickets cerrados',
    },
  },
};
